import { Injectable } from '@angular/core';
import { Firestore, addDoc, arrayUnion, collection, collectionData, doc, docData, getDoc, getDocs, orderBy, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { SharedService } from '../../../../shared/shared.service';
import { getDownloadURL, getStorage, ref } from '@angular/fire/storage';
import { HttpClient } from '@angular/common/http';
import firebase from 'firebase/compat';
​
@Injectable({
    providedIn: 'root'
})
export class MiniClipsService {
​
    userId: any;
    constructor(
        private firestore: Firestore,
        private sharedService: SharedService,
        private httpClient: HttpClient
    ) {
        this.userId = localStorage.getItem("userId");
     }
​
​
    async addMiniClips(data:any) {
      const ref = collection(this.firestore, `miniClips`);
      return await addDoc(ref, data);
  }
​
	getMiniClips() {
		const miniClipsRef = collection(this.firestore, 'miniClips');
		const q = query(miniClipsRef, where('active', '==', true))
		return getDocs(q).then((querySnapshot) => {
			const data:any = [];
			querySnapshot.forEach((doc) => {
				data.push({ id: doc.id, ...doc.data() });
			});
			data.sort((a: any, b: any) => {
				if (a.order < b.order) {
					return -1;
				} else {
					return 1;
				}
			});
			return data;
		});
	}

    getUserMiniClips() {
        console.log('this.userId', this.userId)
        const miniClipsRef = collection(this.firestore, `users/${this.userId}/miniClips`);
        const q = query(miniClipsRef, orderBy('order'));
        return getDocs(q).then((querySnapshot) => {
            console.log('querySnapshot', querySnapshot);
          const data:any = [];
          querySnapshot.forEach((doc) => {
            console.log('doc', doc);
              data.push({ ...doc.data(), id: doc.id });
          });
          console.log('data', data);
          return data;
      });
    }

    async updateMiniClipsProgress(data: any){
      console.log('this.userId', this.userId)
      const updateMiniClipsRef = doc(this.firestore, `users/${this.userId}`);
      await updateDoc(updateMiniClipsRef, {miniClipsData: data});
      return true;
    }

    async updateTotalMiniClipsProgress(totalVideosDuration: any, id:string){
      const updateMiniClipsRef = doc(this.firestore, `miniClips/${id}`);
      updateDoc(updateMiniClipsRef, {totalDurationClips: totalVideosDuration});
      return true;
    }




}